"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_emotion_1 = __importDefault(require("react-emotion"));
const DefaultCursorLink = react_emotion_1.default('a') `
  cursor: default;
`;
exports.default = ({ onClick, hide = false }) => (!hide || null) && (React.createElement(DefaultCursorLink, { className: "awsui-util-help-info-link", onClick: onClick }, "Info"));
//# sourceMappingURL=HelpInfoLink.js.map